<template>
  <div id="approval-buttons" class="d-flex flex-row i-gap-2">
    <status-button
      label="Reject"
      data-testid="reject-button"
      :btn-status="statusButtonOptions.REJECT"
      :on-btn-click="rejectCustomer"
      icon="small-user-reject"
      :active="isCustomerRejected"
      active-class="i-text-error-90"
    ></status-button>

    <status-button
      label="Approve"
      data-testid="accept-button"
      :btn-status="statusButtonOptions.APPROVE"
      :on-btn-click="approveCustomer"
      icon="small-user-approve"
      :active="isCustomerApproved"
      active-class="i-text-success-90"
    ></status-button>
  </div>
</template>

<script>
import * as documentStatusOptions from '@/constants/documentStatus';
import { mapActions, mapMutations } from 'vuex';
import StatusButton from '@/V2/components/StatusButton';
import { StatusButtonOptions } from '@/constants/statusButtonOptions';
import palette from '@inscribe/signal/dist/palette';

export default {
  components: {
    StatusButton,
  },
  props: {
    customer: {
      type: Object,
      required: true,
    },
    groupedParsedDetails: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    options: documentStatusOptions,
    statusButtonOptions: StatusButtonOptions,
    palette,
    loading: false,
  }),

  computed: {
    isCustomerApproved() {
      return this.customer && this.customer.approved === true;
    },
    isCustomerRejected() {
      return this.customer && this.customer.approved === false;
    },
    customerApprovalNull() {
      return this.customer && this.customer.approved === null;
    },
  },
  mounted() {
    this.setShowBlocklistSuggestions(false);
  },
  methods: {
    ...mapActions(['updateCustomer']),
    ...mapMutations([
      'setShowBlocklistSuggestions',
      'setSelectedCustomer',
      'updateCustomerState',
    ]),
    rejectCustomer() {
      this.setCustomerApproved(false);
      if (this.groupedParsedDetails && this.groupedParsedDetails.length > 0) {
        setTimeout(() => {
          this.setShowBlocklistSuggestions(true);
        }, 600);
      }
    },
    approveCustomer() {
      this.setCustomerApproved(true);
    },
    setCustomerApproved(isApproved) {
      let newValue = isApproved;
      if (
        (isApproved === true && this.customer.approved === true) ||
        (isApproved === false && this.customer.approved === false)
      ) {
        newValue = null;
      }
      this.loading = true;
      const updatedCustomer = {
        ...this.customer,
        approved: newValue,
      };
      this.updateCustomer({
        ...updatedCustomer,
        addresses: undefined,
        phone_numbers: undefined,
        tins: undefined,
        emails: undefined,
      });
      this.setSelectedCustomer(updatedCustomer);
      this.updateCustomerState({
        objectsName: 'list',
        updatedObject: updatedCustomer,
      });
      this.loading = false;
    },
  },
};
</script>
